import axios from 'axios'
import * as types from '../mutation-types'
import { getNoticeList } from '@/api/url'
import { getInfo } from '@/assets/func'

const state = {
  currentNoti: {},
  currentPage: 1,
  noticeList: [],
  totalCnt: 0
}

const getters = {
  // 10개씩 내보내기
  getNotice: state => {
    let start = (state.currentPage - 1) * 10
    let end = start + 10
    let res = []

    for (let i = start; i < end && state.noticeList[i] !== undefined; i++) {
      res.push(state.noticeList[i])
    }

    return res
  }
}

const actions = {
  // get notice list
  getNoticeRequest: ({ commit }) => {
    // params -> &uid=[사용자ID]
    let uid = getInfo().uid
    let url = getNoticeList + uid
    axios.get(url).then((res) => {
      commit(types.SET_NOTICE_LIST, {list: res.data})
    }, (err) => {
      console.error(err)
    })
  }
  // setNotice: (noti) => {
  //   return axios.post('url', noti).then((res) => {
  //     return true
  //   }, (err) => {
  //     console.error(err)
  //   })
  // }
}

const mutations = {
  [types.SET_NOTICE_LIST]: (state, { list }) => {
    state.noticeList = list
    state.totalCnt = list.length
  },
  [types.SET_NOTICE_PAGE]: (state, pNum) => {
    state.currentPage = pNum
  },
  setCurrentNoti: (state, notice) => {
    state.currentNoti = notice
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/notice.js